import * as React from "react";

function SvgStateParentHover(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path className="state-parent-hover_svg__st0" d="M9.8 15.8c-.3 0-.6-.2-.7-.5l-3.8-9c-.1-.3 0-.6.2-.8.2-.2.5-.3.8-.2l9 3.8c.3.1.5.4.5.7 0 .3-.2.6-.5.7l-3.6 1.2-1.2 3.6c-.1.2-.4.4-.7.5zM7.4 7.4l2.3 5.5.7-2c.1-.2.2-.4.5-.5l2-.7-5.5-2.3z" /><path className="state-parent-hover_svg__st0" d="M6.4 12.8H2.2V2.2h11.5v4.5l1.5.6V1.5c0-.4-.3-.8-.8-.8h-13c-.4 0-.8.3-.8.8v12c0 .4.3.8.8.8H7l-.6-1.5z" /></svg>;
}

export default SvgStateParentHover;